var site = "https://doylestaging.roswellstudios.com";
var globalcolor = '';
var allsizes = null;
var goColorDropdownGetSizes_AlreadyRanOnThisPage = '';

  function setLocator()
  {
    setTimeout(function(){
		setNote();
        setUpWearDateHandler();
        $('body').on('click',".locator2",function(event){
          event.preventDefault();
          $('#storeFrame').show();
          $("html, body").animate({ scrollTop: 0 }, "slow");
          $("#myiFrame").addClass('show');
          var iframe = $("#myiFrame");
          iframe.attr("src", iframe.data("src"));
          goHijackMapAutolocate();
        });
	}, 100);
  }

/***********************************/
/*    DETAIL - SIZE CLICK POPUP    */
/***********************************/

function sizeLabelHandler(e) {

  $("span.fit, a.fit").on('click', function(e) {
    if($(this).parent().attr('href')) {
      e.preventDefault();
    }
    $('#sizeChart').show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });

  $('button.close-form').on('click', function(){
    $('#sizeChart').hide();
  });
}

function goColorDropdownGetSizesPre(color,isquickview)
{
  var d = new Date();
  console.log(d.getTime().toString() + ' goColorDropdownGetSizesPre STARTING');
  isquickview = typeof isquickview !== 'undefined' ? isquickview : false;
  if (allsizes !== null  && allsizes.length > 0)
  {
    goColorDropdownGetSizes(color,isquickview);
    return;
  }
  var loginemail = $('#currentemail').val();
  var posturl = site + "/apps/getsizes";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { name : isquickview?$('h2:last').html():$('.page-title').html() },  //h2:last not great
    success: function (data) {
      d = new Date();
  		console.log(d.getTime().toString() + ' goColorDropdownGetSizesPre Back from async');
      allsizes = data.info;
      sizeLabelHandler();
      goColorDropdownGetSizes(color,isquickview);
      return;
    },
    error: function(data) {
      console.log(data);
    }
  });
}

 function goColorDropdownGetSizes(color,isquickview)
  {
    var d = new Date();
  	console.log(d.getTime().toString() + ' goColorDropdownGetSizes STARTING ' + color);

    if (goColorDropdownGetSizes_AlreadyRanOnThisPage == color)
      return;
    goColorDropdownGetSizes_AlreadyRanOnThisPage = color;

    isquickview = typeof isquickview !== 'undefined' ? isquickview : false;
    if (color == null) 	color = 'BLACK';//return;
    color = color.toUpperCase();
    console.log(allsizes);
    var thiscolor = null;
    if (color == null || allsizes[0].color == null)
    {
      thiscolor = allsizes[0];
    }
    else
    {
      for (var i in allsizes)
      {
        if (allsizes[i].color.toUpperCase() == color)
        {
          thiscolor = allsizes[i];
        }
      }
    }
	if (thiscolor == null)
    {
      console.log('this color is null');
      return;
    }
    if ($("#size"))
      $("#size").remove();
    if ($("#sizelabel").length > 0)
    {
    	$("#sizelabel").after("<div class='clear'></div><div id='size' class='template-product'></div>");
    }
    else
    {
        $("select[data-option='option1']").before("<div id='size' class='template-product'></div>");
    }
    $('.thumb:gt(0)').remove();
    console.log(thiscolor);
    for (var j in thiscolor.images)
    {
      if($(window).width()<768){
        console.log(thiscolor.images[j] + '-----' + j);
        if (j == 1)
        {
        	if ($('#carrysell').length == 0)
            {
              var carsl = '<div id="carrysell" class="owl-carousel owl-theme" style="height:'+$('.bigimage').height()+'px;width:'+$('.bigimage').width()+'px;">';
              $('.bigimage').wrap(carsl);
              $('.bigimage').after($('.bigimage').clone(true, true));
            }
            $('.bigimage:eq(0)').find('.mainimage').attr('src',thiscolor.images[0]);
            $('.bigimage:eq(1)').find('.mainimage').attr('src',thiscolor.images[1]);
            goMobilePDPCarrysell();
        }
      }
      else
      {
        if (j == 0){
          $('.thumb:first').attr('href',thiscolor.images[j]);
          $('.thumb:first').find('img').attr('src',thiscolor.images[j].replace('.jpg','_medium.jpg'));
          $('.thumb:first').css('display','block');
        }
        else if (j == 1)
        {
          $('.thumb').last().after($('.thumb').last().clone(true, true));
          $('.thumb').last().attr('href',thiscolor.images[j]);
          $('.thumb').last().removeClass('active');
          $('.thumb').last().find('img').attr('src',thiscolor.images[j].replace('.jpg','_medium.jpg'));
        }
        $('.thumb:gt(0)').removeClass('active');
        $('.thumb:first').addClass('active');
        $('.thumbnails').show();
      }
    }
    $('.thumb:first').click();
    if ($('#breadcrumb').find('a').length > 1)
    {
      $('#breadcrumb').find('a:eq(1)').text(localStorage.getItem('_lastcollectiontitle'));
      $('#breadcrumb').find('a:eq(1)').attr('href',localStorage.getItem('_lastcollectionurl'));
    }

    for (var i in thiscolor.sizes)
    {
        var sku = thiscolor.sizes[i].sku;
        var display = sku;
        var id = thiscolor.sizes[i].id;
        var size = thiscolor.sizes[i].size;
        var inventory_quantity = thiscolor.sizes[i].inventory_quantity||0;
        var viz = '';
      var lenmode = 'reg';
      if (thiscolor.sizes[i].sku.toUpperCase().indexOf("REG") == -1) {
          viz = 'style="display:none;"';
        lenmode = 'xl4';
      }
	  	var opt = '<label ' + viz + ' class="opt-container ' + sku
        +(inventory_quantity<=0 && thiscolor.sizes[i].inventory_policy != 'continue'?' soldout':'')
        +' ' + lenmode
        +'" for="'+ size +'"><input id="'+ size +'" data-qty="' + inventory_quantity + '" data-skd="' + id + '" val="' + id + '" type="radio" /><span>'+ size +'</span></label>';
       	$("#size").append(opt);
    }
    $("#size").after($("<div class='clear'></div>"));
    if ($("div.xtra").length > 0)
    {
      if ($("#size label.xl4").length > 0){
        $("div.xtra").show();
        $("#extralength").on('click', function(){
          setsku();
          if ($('#extralength').is(':checked') == true) {
            $('#size .xl4').show();
            $('#size .reg').hide();
          } else {
            $('#size .xl4').hide();
            $('#size .reg').show();
          }
          $('select#currencies').trigger('change');
        });
      } else { $("div.xtra").hide(); }
    }

    $(".opt-container").on('click', function(){
      if ($(this).hasClass('soldout')) { return; }
       var skd = $(this).find('input').data("skd");
       $("#qqty").remove();//what? .val()?
      	$("body").append("<input type='hidden' id='qqty' value='" + $(this).find('input').data("qty") + "' ></input>");
        $(".opt-container").removeClass('selected');
    	$(this).addClass('selected');
       setsku();
    });

    if ($('.selector-wrapper').find('label').length > 0)
   		$('.selector-wrapper').find('label').first().remove();
    if ($('.sizelabel').length > 1)
      $('.sizelabel:eq(1)').remove();
    $("label:contains('SIZE ')").remove();

    d = new Date();
  	console.log(d.getTime().toString() + ' goColorDropdownGetSizes ENDING');
    if (!isquickview)  //let main image finish loading//should do that, then, and not setTimeout
    {
    	setTimeout(function(){
			related(color);
		}, 1000);
    }
  }

 function setsku()
  {
    var skew = $(".opt-container.selected").find('input').data("skd");
	if (!$("input[data-skd='" + skew + "']").parent().attr('class'))
      return;

      var classes = $("input[data-skd='" + skew + "']").parent().attr('class').split(' ');
      var thisclass = "";
      for (var j in classes)
      {
        if (classes[j].indexOf('REG') > -1 || classes[j].indexOf('XL4') > -1)
          thisclass = classes[j];
      }
      if ($('#extralength').is(':checked') == false)
        skew = $('.' + thisclass.replace('XL4','REG')).find('input').data('skd');
      else
        skew = $('.' + thisclass.replace('REG','XL4')).find('input').data('skd');
       $("select[name='id']").append($("<option></option>")
 			.attr("value",skew)
             .text(skew));
       $("select[name='id']").val(skew);

    if ($('select#currencies').val() == 'CAD')
    {
     	getCADproduct(skew,false);
    }
    if ($("input[data-skd='" + skew + "']").data("qty") > 0) {
      	$('#stockicon').html('<i class="fa fa-truck" aria-hidden="true"></i>')
      	$('#stockmessage').html("Your selection is in-stock.  We'll ship it to you on the business day following your transaction and you should receive it in <u>approximately a week</u>.");
    }
    else {
      	$('#stockicon').html('<i class="fa fa-truck" aria-hidden="true"></i>')
        $('#stockmessage').html('This is a special order style that will be delivered to you in <u> 12-14 weeks</u>.');
    }
  }

function getCADproduct(id,iscart)
{
  var posturl = site + "/apps/getOtherCountryProduct/" + id;
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { },
    success: function (data) {
      if (!data.success)
        return;
      if (!(data.id != id && data.id.toString().length > 5))
        return;
      var valueSelected = $('select#currencies').val()
      if (data.country == 'ca' && (valueSelected != 'CAD'))
        return;
      if (data.country == 'us' && (valueSelected != 'USD'))
        return;
      if (iscart)
      {
        jQuery.post('/cart/update.js', 'updates['+id+']=0');
        jQuery.post('/cart/add.js', {quantity: 1,id: data.id});
        jQuery.post('/cart/update.js', 'updates['+id+']=0');
      }
      else
      {
        $("select[name='id']").append($("<option></option>")
                                      .attr("value",data.id)
                                      .text(data.id));
        $("select[name='id']").val(data.id);
      }
    },
    error: function(data) {
      console.log('error');
      console.log(data);
    }
  });
}

 function getParentColor(chilcol)
  {
  	var groups = $('#colors').val().split("*");
    for (var i in groups)
    {
      var sings = groups[i].split(',');
      for (var j in sings)
      {
      	if (sings[j].indexOf(chilcol) > -1)
          return sings[0];
      }
    }
    return '';
  }

function updateCartCountry()
{
  var valueSelected = $('select#currencies').val();

  if (valueSelected == 'CAD')
  {
    var total = 0;
    data = JSON.parse(localStorage.getItem('_products'));
    $('.ajaxcart__inner .prod-desc').each(function(event){
      var title = $(this).find('a.ajaxcart__product-name').text();
      console.log(title);
      for (i in data.products)
      {
        if (data.products[i].title == title)
        {
          var val = data.products[i].priceca.replace('$','');
          var str = $(this).find('.ajaxcart__product-meta').text();
          console.log(str);
          val = val / Currency.rates['CAD'];
          val = val + .02;
          console.log(val);
          if (str.toLowerCase().indexOf('extra') > -1)
            val += 10;
          console.log(val);
          val = Math.floor(val);//.toString()
          total += $(this).find('.ajaxcart__qty-num').val() * val;
          val = '$' + val + '.00 CAD';
          $(this).find('span.money').text(val);
        }
      }
    });
    $('.ajaxcart__footer span.money').text('$' + Math.floor(total) + '.00 CAD');
  }
  else
  {
    var total = 0;
    data = JSON.parse(localStorage.getItem('_products'));
    $('.ajaxcart__inner .prod-desc').each(function(event){
      var title = $(this).find('a.ajaxcart__product-name').text();
      console.log(title);
      for (i in data.products)
      {
        if (data.products[i].title == title)
        {
          var val = data.products[i].price.replace('$','');
          val = val / 1;
          var str = $(this).find('.ajaxcart__product-meta').text();
          if (str.toLowerCase().indexOf('extra') > -1)
            val += 10;
          total += $(this).find('.ajaxcart__qty-num').val() * val;
          val = '$' + val + '.00';
          $(this).find('span.money').text(val);
        }
      }
    });
    $('.ajaxcart__footer span.money').text('$' + Math.floor(total) + '.00');
  }

}



function getDressingRoomDetails()
{
  var loginemail = $('#currentemail').val();
  var posturl = site + "/apps/dressingroomdetails";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { id : localStorage.getItem('_dri'), email : loginemail },
    success: function (data) {
      data = $.parseJSON(data);
      console.log(data.details);
      $('#eventname').val(data.details.name);
      $('#eventzipcode').val(data.details.zipcode);
      $('#rpassword4').val(data.details.password);
      $('#eventurl').val(data.details.url);
      $('#eventdetails').val(data.details.details);
      $('#eventnotes').val(data.details.notes);
      $('#eventtheme').val(data.details.theme);
      $('#rid').val(data.details.id);
    }
  });
}

function getDressingRoom(targetid)
{
  var loginemail = $('#currentemail').val();
  var posturl = site + "/apps/wishlist3";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  if (loginemail.trim().length == 0)
    loginemail = localStorage.getItem('_email');
  //  return;
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { id : localStorage.getItem('_dri'), email : loginemail },
    success: function (data) {
      //console.log(data);
      $('#'+targetid).html(data);
      $('h1').text($('#nameh').val());
      if ($('#eventid').data('owner') == true)
        $('#editspan').show();
      else
        $('#editspan').hide();
      $.getScript( "https://assets.pinterest.com/js/pinit.js" );
      $('#connect').click(function(e){
        addPin($('#pinter').val(),$('#eventid').val());
      });
      goFavoriteCarousel();
      $('.fav-dresses .desktop-3').css('width','85%');

      localStorage.setItem('_store_dr', $('#drstore').val());
      localStorage.setItem('_store_dr_address', $('#drstore_address').val());
      localStorage.setItem('_store_dr_phone', $('#drstore_phone').val());
      localStorage.setItem('_store_dr_name', $('#drstore_name').val());
      localStorage.setItem('_store_dr_code', $('#drstore_code').val());

      $('#inviteform').on('submit', function(e){
        invitetowishlist($('#inviteemail').val());
        e.preventDefault();
        e.stopPropagation();
      });

    }
  });
}

function invitetowishlist(email)
{
  var site = "https://doylestaging.roswellstudios.com";
  var posturl = site + "/apps/invitetowishlist/";

  var wid = localStorage.getItem('_dri');
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {wid : wid,email : email,name : $('#currentname').val()},
    success: function (data) {
      window.location.href="/pages/dr";
    },
    error: function(data) {
    }
  });
}

function goFavoriteCarousel()
{
  done = true;
  $("#owl").owlCarousel({
    navigation : true,
    nav: true,
    navigationText: ["",""],
    slideSpeed : 300,
    paginationSpeed : 400,
    singleItem: false,
    pagination: true,
    addClassActive: true,
    loop: true,
    slideBy: 2,
    items: 4,
    responsive: {
      0 : {
          loop : true,
          items: 2,
      },
      480 : {
          loop : true,
          items: 2,
      },
      768 : {
          loop : true,
          items: 4,
      }
    }
  });
}

function goMobilePDPCarrysell()
{
 setTimeout(function(){
   $("#carrysell").owlCarousel({
    navigation : true,
    nav: true,
    navigationText: ["",""],
    slideSpeed : 300,
    paginationSpeed : 400,
    singleItem: true,
    pagination: true,
    addClassActive: true,
    loop: true,
    slideBy: 1,
    items: 1,
    responsive: {
      0 : {
          loop : true,
          items: 1,
      },
      480 : {
          loop : true,
          items: 1,
      },
      768 : {
          loop : true,
          items: 1,
      }
    }
  });
 }, 200);
}

function addPin(earl,id)
{
  var posturl = site + "/apps/addlink";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: { id : id, url : earl },
    success: function (data) {
      window.location.reload();
    },
    error: function(data) {
    }
  });
}

function goToDressingRoom(pid,color)
{
  pid = typeof pid !== 'undefined' ? pid : 0;
  color = typeof color !== 'undefined' ? color : '';
  var loginemail = $('#currentemail').val();
  if (loginemail.trim().length == 0)
    return;
  console.log(loginemail);
  var posturl = site + "/apps/getWishlists";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {email:loginemail},
    success: function (data) {
      console.log(data);
      var jay = $.parseJSON(data);
      console.log(jay);
      if (jay.success)
      {
        var i;
        var content = "";
        var jw = jay.wishlists;
        if (jw.length == 1)
        {
          godr(jw[0][0]);
          return;
        }
        for (i in jw)
        {
          if (pid == 0)
            content += "<p class='rm-select'><a href='javascript:godr(" + jw[i][0] + ")'>" + jw[i][1] + "</a></p>";
          else
            content += "<p class='rm-select'><a href='javascript:addtowishlistgo(" + pid + "," + jw[i][0] + ",\"" + color + "\")'>" + jw[i][1] + "</a></p>";
        }
        content += "<p class='rm-select'><a href='/pages/dressing-room-create'>Create A Dressing Room</a></p>";
        content += "<p class='rm-select'><a href='/pages/dressing-room-register'>Join A Dressing Room</a></p>";
        if (pid == 0)
          var dialog = $("<div id='dialog-message' title='Select Dressing Room'>" + content + "</div>").dialog({
            dialogClass:"dr-pop",
            width: 600,
            maxWidth: 600,
            height: 'auto',
            modal: true,
            fluid: true,
            resizable: false
          });
        else
          var dialog = $("<div id='dialog-message' title='Add Product to Dressing Room'><p>" + content + "</p></div>").dialog({
            dialogClass:"dr-pop",
            width: 600,
            maxWidth: 600,
            height: 'auto',
            modal: true,
            fluid: true, //new option
            resizable: false
          });
      }
      else
      {
        alert('Login failed...please correct details and try again.');
      }
    }
  });
}

 function addtowishlist(pid,color,vid)
  {
    if ($('#currentemail').val().length == 0)
      {
        setupAddToDressingRoom(pid+'^'+color);

        /*if (window.location.href.indexOf('?') > -1)
          $("input[name='checkout_url']").val(window.location.href+"&wlc");
        else
          $("input[name='checkout_url']").val(window.location.href+"?wlc");*/
          //e.preventDefault();
    	  //e.stopPropagation();
        $( ".menu_c:first" ).dialog({
          dialogClass:"dr-pop",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false
        });
          $(".ui-dialog-title").html("Sign In or Create Account");
          return;
      }
    var wid = localStorage.getItem('_dri');
    addtowishlistgo(pid,wid,color,vid);
    //goToDressingRoom(pid,color);
  }

function addtowishlistgo(pid,wid,color,vid)
{
  var site = "https://doylestaging.roswellstudios.com";
  var posturl = site + "/apps/addtowishlist/";
  var id = pid;

  if (wid == 0)
    wid = localStorage.getItem('_dri');
  else
    localStorage.setItem('_dri', wid);

  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {id:id,wid : wid,color : color,vid:vid},
    success: function (data) {
      console.log(data['success']);
      if (data['success'] == true)
      {
        console.log('about to show dialog');
        $(this).find('.hov').show();
        $(this).find('.emp').hide();
        var dialog = $("<div id='dialog-message-cong'>Congratulations! Your dress has been added to " + data['name'] + " dressing room!</div>").dialog({
          dialogClass:"notification",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false
        });
        $(dialog).dialog('open');
        console.log('dialog should be open');
        setTimeout(function(){
          $(dialog).dialog('close');
          $(".ui-dialog-content").dialog("close");
        }, 4000);
        //window.location.href="/pages/dr";
      }
      else
      {
        /*var dialog = $("<div id='dialog-message-cong'>This product already exists in your dressing room!</div>").dialog({
          dialogClass:"notification",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false
        });
        setTimeout(function(){
          $(dialog).dialog('close');
        }, 5000); */
      }
      if ($('#dialog-message').length > 0)
        $('#dialog-message').dialog('close');

    },
    error: function(data) {

    }
  });

}


function deletefromwishlist(email)
{
  var site = "https://doylestaging.roswellstudios.com";
  var posturl = site + "/apps/deletefromwishlist2/";

  var wid = localStorage.getItem('_dri');
  $('<div></div>').appendTo('body')
  .html('<div><h6>'+'Delete ' + email + '?</h6></div>')
  .dialog({
    modal: true, title: 'Add to cart', zIndex: 8050, autoOpen: true,
    width: 'auto',
    resizable: false,
    dialogClass:"dr-pop",
    maxWidth: 600,
    height: 'auto',
    fluid: true, //new option
    buttons: {
      Yes: function () {
        $(this).dialog("close");
        $.ajax({
          type: 'POST',
          url: posturl,
          timeout:300000,
          data: {email:email,wid : wid},
          success: function (data) {
            console.log(data);
            if (data['success'])
            {
              window.location.href="/pages/dr";
            }
            else
            {
            }},
          error: function(data) {
          }
        });
      },
      No: function () {
        $(this).dialog("close");
      }
    },
    close: function (event, ui) {
      $(this).remove();
    }
  }).dialog( "moveToTop" );

}


function maketopfavorite(id)
{
  var site = "https://doylestaging.roswellstudios.com";
  var posturl = site + "/apps/maketopfavorite/";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {id:id},
    success: function (data) {
      window.location.href="/pages/dr";
    },
    error: function(data) {
    }
  });
}

 function joinDressingRoomModal()
  {
    var content = '  <div id="join"> ' +
    	'<div class="input"><p>Dressing Room Admin Email <span class="ast">*</span> </p><input type="text" id="rloginid3"/></div> ' +
    	'<div class="input"><p>Password <span class="ast">*</span></p><input type="text" id="rpassword3"/></div> ' +
    	'<div class="join-btn"><input type="button" id="joinaction3" value="JOIN" /></div> ' +
  		'</div>';
	var dialog = $("<div id='dialog-message' title='Join Dressing Room'><p>" + content + "</p></div>").dialog({
      dialogClass:"dr-pop",
      width: 600,
      maxWidth: 600,
      height: 'auto',
      modal: true,
      fluid: true, //new option
      resizable: false
	});

    $('#joinaction3').on('click', function(){
    	joinDressingRoom($('#rloginid3').val(),$('#rpassword3').val(),$('#currentemail').val());
  	   });
  }

function deleteComment(id)
{
  var site = "https://doylestaging.roswellstudios.com";
  var posturl = site + "/apps/deleteComment/";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {id:id},
    success: function (data) {
      $('.ui-dialog-titlebar-close').click();
      $('#comment').remove();
      $('#commentaction').remove();
      $(".ui-dialog-content").remove();
    },
    error: function(data) {
    }
  });
}

 function commentModal(id)
  {
    $(".ui-dialog-content").dialog("close");
    $('#comment').remove();
    $('#commentaction').remove();
    $(".ui-dialog-content").remove();
    var content = '  <div id="comment"> ' +
    	'<div>Comment:<input type="text" id="commentC"/></div> ' +
    	'<div><input type="button" id="commentaction" value="Submit" /></div> ' +
  		'</div>';
	var posturl = site + "/apps/getComments";
    $.ajax({
      type: 'POST',
      url: posturl,
      timeout:300000,
      data: { id : id },
      success: function (data) {
        var jay = $.parseJSON(data);
        console.log(jay);
        var owner = (jay['owner'] == $('#currentemail').val()) ? true : false;
        console.log(owner);
        for (i in jay['comments'])
        {
          content = content + '<div>';
          if (owner)//($('.aowner').val() == $('.currentemail').val())
            content = content + '<button type="button" onclick="deleteComment(' + jay['comments'][i][3] + ')" class="ui-button ui-corner-all ui-widget ui-button-icon-only" style="height:20px;width:20px;margin-top:6px;margin-right:4px;padding:1px;" title="Close"><span class="ui-button-icon ui-icon ui-icon-closethick"></span><span class="ui-button-icon-space"> </span>Close</button>';
          content = content + jay['comments'][i][0] + ' (' + jay['comments'][i][1] + ' '  + jay['comments'][i][2] + ')<br/>';
          content = content + '</div>';
        }
        if ($('.ui-dialog-titlebar-close'))
          $('.ui-dialog-titlebar-close').click();
        var dialog = $("<div id='dialog-message' title='Comment'><p>" + content + "</p></div>").dialog({
          dialogClass:"dr-comment",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false,
          open: function() {
            $('#commentaction').on('click', function(){
              console.log('here3');
              var tname = $('#currentname').val();
              if (tname.trim().length == 0)
                tname = $('#currentemail').val();
              $('a[data-id="'+id.toString()+'"]').parent().addClass('boldcomment')
              comment($('#commentC').val(),id,tname);
            });
          }
        });
      }
    });
  }

function comment(comment,id,email)
{
  var posturl = site + "/apps/comment";
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {comment:comment,id:id,email:email},
    success: function (data) {
      console.log(data);
      if (data['success'])
      {
        $('.ui-dialog-titlebar-close').click();
        $('#comment').remove();
        $('#commentaction').remove();
        $(".ui-dialog-content").remove();
      }
    }
  });
}

 function godr(id)
  {
  	localStorage.setItem('_dri', id);
    window.location.href="/pages/dr";
  }

function loginDressingRoom(u,p)
{
  var posturl = site + "/apps/logindressingroom";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {id:u,pwd:p},
    success: function (data) {
      console.log(data);
      if (data['success'])
      {
        window.location.href="/pages/dr";
        localStorage.setItem('_dri', data['id']);
      }
      else
      {
        alert('Login failed...please correct details and try again.');
      }
    }
  });
}

function joinDressingRoom(u,p,e)
{
  var posturl = site + "/apps/joindressingroom";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: {id:u,pwd:p,email:e},
    success: function (data) {
      console.log(data);
      if (data['success'])
      {
        localStorage.setItem('_dri', data['wid']);
        window.location.href="/pages/dr";
      }
      else
      {
        $('#erm').remove();
        $('#ui-id-1').after('<span id="erm" style="color: red;font-size: 17px;"><br/>' + data['display'] + '</span>');
      }
    }
  });
}

 function createDressingRoom(ser)
 {
   var missingfields = '';
   if ($('#eventname').val().trim().length == 0)
     missingfields = missingfields + "<br/>Event Name";
   if ($('#eventzipcode').val().trim().length == 0)
     missingfields = missingfields + "<br/>Event Zipcode";
   if ($('#rpassword4').val().trim().length == 0)
     missingfields = missingfields + "<br/>Event Password";
   if (missingfields.length > 0)
   {
     var dialog = $("<div id='dialog-message'>Please fill these required fields before continuing:"+missingfields+"</div>").dialog({
       dialogClass:"notification",
       width: 600,
       maxWidth: 600,
       height: 'auto',
       //modal: true,
       //fluid: true, //new option
       resizable: false
     });
     return false;
   }
   var posturl = site + "/apps/createdressingroom";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
   $.ajax({
     type: 'POST',
     url: posturl,
     timeout:300000,
     data: ser,
     success: function (data) {
       console.log(data);
       if (data['success'])
       {

         localStorage.setItem('_dri', data['wid']);
         window.location.href = "/pages/dr";
       }
       else
       {

       }
     }
   });
 }

 function updateDressingRoomStore()
 {
	  var room = $(window.parent.document).find('#eventid').val();
      var store = localStorage.getItem('_store_dr');
      var address = localStorage.getItem('_store_dr_address');
      var phone = localStorage.getItem('_store_dr_phone');
      var name = localStorage.getItem('_store_dr_name');
      var code = localStorage.getItem('_store_dr_code');
           var posturl = site + "/apps/updatedressingroomstore";
     		console.log(posturl);
                 $.ajax({
                    type: 'POST',
                    url: posturl,
                    timeout:300000,
                   data: { rid : room, store : store, store_address : address, store_phone : phone, store_name : name, store_code : code},
                    success: function (data) {
                      console.log(data);
                      if (data['success'])
                      {

                      }
                      else
                      {

                      }
                    }
                  });
 }

 function editDressingRoom(ser)
{
  var posturl = site + "/apps/editdressingroom";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
  $.ajax({
    type: 'POST',
    url: posturl,
    timeout:300000,
    data: ser,
    success: function (data) {
      console.log(data);
      if (data['success'])
      {
        godr(localStorage.getItem('_dri'));
        $('.inlineinput').prop( "disabled", true );
        $('.inlineinput').css("border", "none");
      }
      else
      {

      }
    }
  });
 }


// CLICK PRINT BUTTON ON FIT GUIDE
function printDiv(divName) {
  var printContents = document.getElementById(divName).innerHTML;
  var originalContents = document.body.innerHTML;
  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;

  $('button.close-form').click(function(){
    $('#sizeChart').hide();
  });

  $(".fit").click(function(event) {
	event.preventDefault();
    $('#sizeChart').show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
}



function fluidDialog() {
    var $visible = $(".ui-dialog:visible");
    // each open dialog
    $visible.each(function () {
        var $this = $(this);
        var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
        // if fluid option == true
        if (dialog.options.fluid) {
            var wWidth = $(window).width();
            // check window width against dialog width
            if (wWidth < (parseInt(dialog.options.maxWidth) + 50))  {
                // keep dialog from filling entire screen
                $this.css("max-width", "90%");
            } else {
                // fix maxWidth bug
                $this.css("max-width", dialog.options.maxWidth + "px");
            }
            //reposition dialog
            dialog.option("position", dialog.options.position);
        }
    });

}

function ConfirmDialog(message) {
    $('<div></div>').appendTo('body')
                    .html('<div><h6>'+message+'?</h6></div>')
                    .dialog({
                        modal: true, title: 'Add to cart', zIndex: 8050, autoOpen: true,
                        width: 'auto',
      					resizable: false,
						dialogClass:"dr-pop",
                        maxWidth: 600,
                        height: 'auto',
                        fluid: true, //new option
                        buttons: {
                            Yes: function () {
                                $(this).dialog("close");
                                $('form#AddToCartForm').submit();
                            },
                            No: function () {
                                $(this).dialog("close");
                            }
                        },
                        close: function (event, ui) {
                            $(this).remove();
                        }
                    }).dialog( "moveToTop" );
}

function draddress()
{
  if ((localStorage.getItem('_store') == null) && ($('#drstore').val().length > 0))
  {
    localStorage.setItem('_store', $('#drstore').val());
    localStorage.setItem('_store_name', $('#drstore').val());
    localStorage.setItem('_store_code', $('#drstore').val());
  }
}

function addtocarthandler()
{
  $('#AddToCart').on('click', function(e){
    if ($('.opt-container.selected').length == 0 && window.location.href.indexOf("gift") == -1)
    {
      var dialog = $("<div id='dialog-message'>Please choose your size </div>").dialog({
        dialogClass:"notification",
        width: 600,
        maxWidth: 600,
        height: 'auto',
        modal: true,
        fluid: true, //new option
        resizable: false ,
        zindex: 8050
      }).dialog( "moveToTop" );
     	return false;
    }
    if ($('#qqty').val() == 0)
    {
      	var ret = ConfirmDialog('This is a special order that will be delivered in 12-14 weeks. Would you like to continue');
      	return false;
    }
    return true;
  });
}

function checkouthandler()
{
	$('.cart__checkout,#checkout,#paypal-express-button').on('click', function(e){
      var onlygiftcard = true;
      var store = false;
      var wear = false;
      var message = '';

      if ($('.ajaxcart__product-name').length > 0)
      {
        $('.ajaxcart__product-name').each(function(){
          if ($(this).text().indexOf('Gift') == -1)
            onlygiftcard = false;
        });
      }
      else
      {
        onlygiftcard = false;
      }

      if (onlygiftcard == true)
        return;
/*
      if (localStorage.getItem('_store') != null && localStorage.getItem('_store').indexOf('undefined') > -1 )
        localStorage.setItem('_store','');
      if (localStorage.getItem('_store_dr') != null && localStorage.getItem('_store_dr').indexOf('undefined') > -1 )
        localStorage.setItem('_store_dr','');

      if ((localStorage.getItem('_store_dr') == null || localStorage.getItem('_store_dr').trim().length == 0) && (localStorage.getItem('_store') == null || localStorage.getItem('_store').trim().length == 0))
      {
        store = true;
      }

      if (localStorage.getItem('_wear') == null || localStorage.getItem('_wear').trim().length == 0)
      {
        wear = true;
      }
      */
      //Is somehow making it past this without a store
      //potential prob: looks at local storage, not the actual note.
      var actual = $('#note').val();
      if (actual.match(/Store Name: .+/) == null) {
        store = true;
        var _ = localStorage.getItem('_store');
        //attempt to deal with  the local storage weirdness
        if (_  != null && _.trim().length != 0) {
          store = false;
          $('#note').val('Store Name: ' + localStorage.getItem('_store_name') + '\nAddress: ' + localStorage.getItem('_store_address') + '\nPhone: ' + localStorage.getItem('_store_phone') + '\nStore Code: ' + localStorage.getItem('_store_code') +  $('#note').val());
        }
        _ = localStorage.getItem('_store_dr');
        if (_  != null && _.trim().length != 0) {
          store = false;
          $('#note').val('Store Name: ' + localStorage.getItem('_store_dr_name') + '\nAddress: ' + localStorage.getItem('_store_dr_address') + '\nPhone: ' + localStorage.getItem('_store_dr_phone') + '\nStore Code: ' + localStorage.getItem('_store_dr_code') + $('#note').val());
        }
      }
      if (actual.match(/Wear Date: .+/) == null) {
        wear = true;
        var _ = localStorage.getItem('_wear');
        if (_  != null && _.trim().length != 0) {
          wear = false;
          $('#note').val($('#note').val() + '\nWear Date: ' + _);
        }
      }

      if (store == true || wear == true)
      {
        if (store == true && wear == false)
          message = 'Please choose a store before checking out.';
        else if (store == true && wear == true)
          message = 'Please choose a store and wear date before checking out.';
        else
          message = 'Please choose a wear date before checking out.';
        e.preventDefault();
        e.stopPropagation();
        var dialog = $("<div id='dialog-messagex'>" + message + "</div>").dialog({
          dialogClass:"notification",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false
        });
        return false;
      }
    });
}

 function handleJoinToken()
  {
    var token = '';
    var earl = window.location.href;
    if (earl.indexOf("token=") > -1)
      token = earl.substring(earl.indexOf("token=")+6);
    else if ((localStorage.getItem('_token') != null) && (localStorage.getItem('_token').length > 0))
      token = localStorage.getItem('_token');
    else
      return;

    if (earl.indexOf("register") > -1)
      return;

    //Dont have to be logged in to join via invite now 9/26/18
    /*if ($('#currentemail').val().length == 0)
      {
        localStorage.setItem('_token',token);
        if (window.location.href.indexOf('?') > -1)
          $("input[name='checkout_url']").val(window.location.href);
        else
          $("input[name='checkout_url']").val(window.location.href);
          //e.preventDefault();
    	  //e.stopPropagation();
        $( ".menu_c:first" ).dialog({
          dialogClass:"dr-pop",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true, //new option
          resizable: false
        });
          $(".ui-dialog-title").html("Sign In or Create Account");
          return;
      }*/

    processToken(token);
  }

 function processToken(token)
 {
   var loginemail = $('#currentemail').val();
   var posturl = site + "/apps/processtoken";
   $.ajax({
     type: 'POST',
     url: posturl,
     timeout:300000,
     data: { email : loginemail, token : token },  //h2:last not great
     success: function (data) {
       if(data.success)
       {
         localStorage.removeItem('_token');
         localStorage.setItem('_dri',data.wid);
         localStorage.setItem('_email',data.email);
         window.location.href = "/pages/dr";
         return;
       }
       else
       {
         alert('There was a problem with your invite.  Please try again.');
       }
     },
     error: function(data) {
       console.log(data);
     }
   });
 }

function setUpWearDateHandler()
{
  	$('#weardate').datepicker();
	$('#weardate').change(function() {
		localStorage.setItem('_wear',$('#weardate').val());
      	setNote();
	});
}

function setNote()
{
 	    var store = '';
      	var storex = '';

        if (!(localStorage.getItem('_store') == null || localStorage.getItem('_store').indexOf('undefined') > -1 ))
        {
          store = '<div class="basket-left desktop-8 tablet-3 mobile-3"><p>' + localStorage.getItem('_store_name') + ', ' + localStorage.getItem('_store_address') + ', ' + localStorage.getItem('_store_phone') + '</p><p>' + '<span><a href="#" class="locator2">CHANGE STORE</a></span></p></div>';
          storex = 'Store Name: ' + localStorage.getItem('_store_name') + '\nAddress: ' + localStorage.getItem('_store_address') + '\nPhone: ' + localStorage.getItem('_store_phone') + '\nStore Code: ' + localStorage.getItem('_store_code');
        }
        else if (!(localStorage.getItem('_store_dr') == null ))
        {
          store = '<div class="basket-left desktop-8 tablet-3 mobile-3"><p>' + localStorage.getItem('_store_dr_name') + ', ' + localStorage.getItem('_store_dr_address') + ', ' + localStorage.getItem('_store_dr_phone') + '</p><p>' + localStorage.getItem('_store_dr_code') + ' <span><a href="#" class="locator2">CHANGE STORE</a></span></p></div>';
          storex = 'Store Name: ' + localStorage.getItem('_store_dr_name') + '\nAddress: ' + localStorage.getItem('_store_dr_address') + '\nPhone: ' + localStorage.getItem('_store_dr_phone') + '\nStore Code: ' + localStorage.getItem('_store_dr_code');
        }
    	else
        {
          store = '<div class="basket-left desktop-8 tablet-3 mobile-3"><p><span><a href="#" class="locator2">SELECT STORE</a></span></p></div>';
        }

      	if (!(localStorage.getItem('_wear') == null || localStorage.getItem('_wear').indexOf('undefined') > -1 ))
        {
          $('#weardate').val(localStorage.getItem('_wear'));
          storex = storex + '\nWear Date: ' + localStorage.getItem('_wear');
        }
  		console.log(storex);
  		$('.storedetails').html(store);
      	$('#note').val(storex);

      ShopifyAPI.updateCartNote(storex);
}

function linkclick(link)
{

    if(link.indexOf("room-login") > -1)
    {
      if ($('#currentemail').val().length == 0)
      {
        console.log('loggingin');
        console.log($("input[name='checkout_url']").val());
          //$("input[name='checkout_url']").val($(this).attr("href"));
        if(link.indexOf("room-login") > -1)
        {
        	$("input[name='checkout_url']").val(window.location.href);
            localStorage.setItem('_redir', 'loginda');
        }
        $( ".menu_c:first" ).dialog({
          dialogClass:"dr-pop",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true,
          resizable: false
        });
          $(".ui-dialog-title").html("Sign In or Create Account");
          return false;
      }
    }

    if(link.indexOf("room-login") > -1)
    {
        goToDressingRoom();
    }

}


$(document).ready(function () {

    if ($('#shopifyemail').val().length == 0)
      $('ul.submenu a:contains("New Dressing Room")').remove();
  	if (processSteps())
      return;

  	//console.log($('a[href$="room-login"]').attr('href'));
    //$('a[href$="room-login"]').attr('data-href',$('a[href$="room-login"]').attr('href'));
  	//$('a[href$="room-login"]').removeAttr('href');
    /*var $log = $('a[href$="room-login"]');
  	if ($log.length > 0)
    {
     	//$log.after('<span>' + $log.html() + '</span>');
    }

    var gotodr = '<li><a class="login" onclick="linkclick(\'room-login\');return false;">Go To My Dressing Room</a>';
    var $log = $('a[href$="room-create"]');
  	if ($log.length > 0)
    {
     	 $log.after(gotodr);
      	 $('a.login').css('cursor', 'pointer');
    }*/

  	handleJoinToken();


  try {
    document.fonts.ready.then(function (fontFaceSetEvent) {
      if ($('.home-text').length > 0)
        $('.home-text').show();
      if ($('.content .title').length > 0)
        $('.content .title').show();
    });
	}
  catch(err) {

	}


  var redir = localStorage.getItem('_redir');
  //the if else is for the login redirecting to the dressing room after the user had click on the dressing room without being logged in
    if(window.location.href.indexOf("dressing-room-login") > -1 || redir == 'loginda')
    {
        goToDressingRoom();
    }
    else if(window.location.href.indexOf("dressing-room-register") > -1 || redir == 'join')
    {
        joinDressingRoomModal();
    }
  else if(window.location.href.indexOf("pages/dr") > -1)
  {

  }

  if(window.location.href.indexOf("/cart") > -1)
  {
  		checkouthandler();
  }

  addtocarthandler();

  $('a').not('.thumb').on('click', function(e){
    if(typeof $(this).attr("href") != 'undefined' && (($(this).attr("href").indexOf("dressing-room-login") > -1) || ($(this).attr("href").indexOf("dressing-room-register") > -1) || ($(this).attr("href").indexOf("dressing-room-create") > -1)))
    {
      if ($('#currentemail').val().length == 0)
      {
        console.log('loggingin');
        console.log($("input[name='checkout_url']").val());
          //$("input[name='checkout_url']").val($(this).attr("href"));
        if($(this).attr("href").indexOf("dressing-room-register") > -1)
        {
        	$("input[name='checkout_url']").val(window.location.href);
         	localStorage.setItem('_redir', 'join');
        }
        else if($(this).attr("href").indexOf("dressing-room-login") > -1)
        {
        	$("input[name='checkout_url']").val(window.location.href);
            localStorage.setItem('_redir', 'loginda');
        }
        else if($(this).attr("href").indexOf("dressing-room-create") > -1)
        {
        	$("input[name='checkout_url']").val('/pages/dressing-room-create');
        }
          e.preventDefault();
    	  e.stopPropagation();
          e.cancelBubble = true;
        $( ".menu_c:first" ).dialog({
          dialogClass:"dr-pop",
          width: 600,
          maxWidth: 600,
          height: 'auto',
          modal: true,
          fluid: true,
          resizable: false
        });
          $(".ui-dialog-title").html("Sign In or Create Account");
          return false;
      }
    }

    if(typeof $(this).attr("href") != 'undefined' && $(this).attr("href").indexOf("dressing-room-login") > -1)
    {
        e.preventDefault();
    	e.stopPropagation();
        goToDressingRoom();
    }
    else if($(this).attr("href").indexOf("dressing-room-register") > -1)
    {
        e.preventDefault();
    	e.stopPropagation();
        joinDressingRoomModal();
    }
  });



/*********************************/
/*    RESPONSIVE DIALOG BOXES    */
/*********************************/
// on window resize run function
$(window).resize(function () {
    fluidDialog();
});

// catch dialog if opened within a viewport smaller than the dialog width
$(document).on("dialogopen", ".ui-dialog", function (event, ui) {
    fluidDialog();
});



/*************************/
/*    HEADER DROPDOWN    */
/*************************/
  //$('#nav > li:nth-child(3) > a').removeAttr ('href').off('click');
  //$('#nav > li:nth-child(4) > a').removeAttr ('href').off('click');
  $('#nav > li.dropdown > a').removeAttr ('href').off('click');

  $('body').on('click','#press-modal-overlay',function(){

    $('#press-modal-overlay').fadeOut(function(){
      $(this).remove();
    });
    $('#press-modal').fadeOut(function(){
      $(this).remove();
    });

  });

/************************/
/*   OPEN PRESS ITEMS   */
/************************/

  $('.press_item a, .article a').click(function(e){
    //open modal

    e.preventDefault();
	$('body').append('<div id="press-modal-overlay"><div id="press-modal"><img src="'+$(this).attr('href')+'"></div></div>');
    $('#press-modal').css({
      top:$('body,html').scrollTop()+100+'px'
    });
    $('#press-modal, #press-modal-overlay').fadeIn();

  });


/********************************/
/*   OPEN PRODUCT DESCRIPTION   */
/********************************/

  $('.open-details').on('click', function(){
    $(this).hide();
    $('.close-details').show();
    $('.m-desc').slideToggle();
  });

  $('.close-details').on('click', function(){
    $(this).hide();
    $('.open-details').show();
    $('.m-desc').slideToggle();
  });


/********************/
/*    ORDER FORM    */
/********************/

  if(window.location.href.indexOf("contact_form") > -1) {
	$('.formOverlay').show();
    console.log('contact-form');
  }

  if($(".formOverlay .successForm.feedback").is(':visible')){
  	$(contactFormWrapper).hide();
  }

//   $('#email-order-form').click(function()
  $('footer .row div:nth-child(5) ul li:nth-child(3)').click(function(event){
	event.preventDefault();
    $('#contactForm').show();
  });

  $('button.close-form').click(function(){
    $('#contactForm').hide();
  });

/*****************************/
/*    STORE LOCATOR POPUP    */
/*****************************/

$("#store, .store, .locator, #prod-store, .locate, .m-image-block-container #block-4, .d-image-block-container #d-block-6").click(function(event){
  console.log('maps!');
  event.preventDefault();
  $("#myiFrame").after($("#myiFrame").clone().attr("id","myiFrame2"));
  $("#myiFrame").remove();
  $("#myiFrame2").attr("id","myiFrame");
  $('#storeFrame').show();
  $("html, body").animate({ scrollTop: 0 }, "slow");
  $("#myiFrame").addClass('show');
  var iframe = $("#myiFrame");
  iframe.attr("src", iframe.data("src"));
  $(document).add(parent.document).mouseup(function(e) {
      var cont = $('#myiFrame');
      if (!cont.is(e.target) && cont.has(e.target).length === 0) {
          cont.attr("src","");
          //cont.hide();
          $("#myiFrame").removeClass('show');
          $('#storeFrame').hide();
      }
  });

  iterations = 0;
  goHijackMapAutolocate();
});

  $('button.close-form').click(function(){
    $('#storeFrame').hide();
  });


$('iframe').load( function() {
  try{
    $('iframe').contents().find("head")
      .append($("<style type='text/css'>  header, footer, #newsletter {display:none;}  </style>"));
//?view= instead? This is trying to edit everything, and failing
  } catch(e) {}
});


/********************************************/
/*    DRESSING ROOM - FAVORITES CAROUSEL    */
/********************************************/

  $(".product-collection-carousel").owlCarousel({
    itemsCustom : [
      [0, 2],
      [450, 2],
      [600, 2],
      [700, 2],
      [1000, 4],
      [1200, 4],
      [1400, 4],
      [1600, 5]
    ],
    lazyLoad : true,
    navigation : true,
    navigationText: ["",""],
    pagination: false
  });

      $('.product-modal').on('click', function(){

      });
  $("#d-prod-room,#d-prod-room2,.d-prod-room-link").on('click', function(){
    		addtowishlist($(this).data("id"),$("select[data-option='option1']").val());
  });

  $("#wishlist").on('click', function(){
			var site = "https://doylestaging.roswellstudios.com";

    //passing on url so can manually test in browser
            var posturl = site + "/apps/wishlist/";// + $('#id1').val() + "?swatch=" + encodeURIComponent(picone) + "&inlay=" + encodeURIComponent(pictwo) + "&dimension=" + encodeURIComponent (dimension) + "&price=" + encodeURIComponent (price);
     		console.log(posturl);
                 $.ajax({
                    type: 'POST',
                    url: posturl,
                    timeout:300000,
                    data: 1,
                    success: function (data) {
                      console.log(data);
                      //var json = $.parseJSON(data);
                      console.log(data.products);
                  localStorage.setItem('_wproducts', 'testproduct987');
  /*var value = "testvalue999";
  var form = $('<form action="/apps/apps/apps/wishlist" method="get">' +
  '<input type="hidden" name="products" value="' + value + '"></input>' + '</form>');
  $('body').append(form);
  $(form).submit();*/
                      window.location.href="/apps/apps/apps/wishlist";

                    }
                  });

   });




/****************************/
/*    LIST - SELECT SIZE    */
/****************************/
  //Highlight the size selection with a border
  $('.opt-container').on('click', function(){
    $('.opt-container').removeClass('selected');
    $(this).addClass('selected');
  });




/***************************************/
/*    SMOOTH TRANSITION TO ID LINKS    */
/***************************************/
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});


/*********************************************************************************************/
/*    BECOME A RETAILER - SEND EMAILS TO APPROPRIATE CONTACTS ACCORDING TO TERRITORY INPUT   */
/*********************************************************************************************/

// Needs to be modified to say its from GG instead of Federalist


  $("#retailerFormSubmit").on('click', function(e){

      e.preventDefault();
      e.stopPropagation();
//    var email = $("#emailU").val();
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
//       var name = $("#nameU").val();

      var firstname = $("#retailerFormFirstName").val();
      var lastname = $("#retailerFormLastName").val();
      var title = $("#retailerFormTitle").val();
      var email = $("#retailerFormEmail").val();
      var phone = $("#retailerFormTelephone").val();
      var store = $("#retailerFormStoreName").val();
      var address = $("#retailerFormAddress").val();
      var state = $("#retailerFormState").val();
      var zipcode = $("#retailerZipcode").val();
      var country = $("#retailerCountry").val();
      var years = $("#retailerBusiness").val();
      var website = $("#retailerWebsite").val();
      var territory = $("#retailerTerritory").val();
      var brands = $("#retailerBrands").val();
      var comments = $("#retailerFormMessage").val();

      if (email === '' || firstname === '' || lastname === '') {
      alert("Please fill all fields...!!!!!!");
      e.preventDefault();
      } /*else if (!(email.match(emailReg))) {
      alert("Invalid Email...!!!!!!");
      e.preventDefault();
      }*/ else {
            var messa = "";

          messa += "<br/>" + $('#retailerFormEmail').prev('label').text() + ":   " + $('#retailerFormEmail').val();

        $('input[type=text]').each(function(){
          if ($(this).attr("id") != "q")
          	messa += "<br/>" + $(this).prev('label').text() + ":   " + $(this).val();
		})
        $('input[type=url]').each(function(){
          messa += "<br/>" + $(this).prev('label').text() + ":   " + $(this).val();
		})
        $('select').each(function(){
    		messa += "<br/>" + $(this).prev('label').text() + ":   " + $(this).val();
		})
        $('textarea').each(function(){
    		messa += "<br/>" + $(this).prev('label').text() + ":   " + $(this).val();
		})

        $("#message").val(messa);//($("#cartF").html());
        $("#name").val(name);
      var territory = $("#retailerTerritory").val();

      if (territory == 'usa') {
        $("#email").val('bridalray@me.com ');
      } else if (territory == 'canada') {
        $("#email").val('joey@feinsteinagencies.com');
      } else {
        $("#email").val('customerservice@gatherandgown.com ');
      }
        $("#email").val('bart@roswellstudios.com');  //temporary override above
        $("#to").val(email);  //should go to customer submitting form also
        console.log($('form#contact_form').serialize());
                var site = "https://doylestaging.roswellstudios.com";
                var posturl = site + "/apps/sendemailTO/";
                console.log(posturl);
                     $.ajax({
                        type: 'POST',
                        url: posturl,
                        timeout:300000,
                        data: $('form#contact_form').serialize(),
                        success: function (data) {
                          console.log(data);
                          alert("Form Submitted Successfully......");
                               },
                        error: function(data) {
                           }
                      });
      }
      });




/*****************/
/*    ADDRESS    */
/*****************/

// ADJUST STYLING OF EDIT ADDRESS FORM
  $('#addresses.customers-addresses .action_edit').click(function(){
    $(this).closest('.address_table').addClass('edit-address');
  });

  $('.edit_address .action_bottom').click(function(){
 	$(this).closest('.address_table').removeClass('edit-address');
  });


// HIDE ADD ADDRESS BUTTON WHEN CLICKED
  $('.customers-addresses .action_add').click(function(){
  	$(this).hide();
  });

  $('#address_form_new .action_bottom').click(function(){
  	$('.customers-addresses .action_add').show();
  });



/******************************************************************/
/* PREVENT REDIRECT WHEN RECOVERING PASSWORD FROM LOGIN DROPDOWN  */
/******************************************************************/

  $('#recover-password form, #recover-password2 form').submit(function(event) {
    event.preventDefault();

    var $form = $( this ),
        url = $form.attr( 'action' );

    var posting = $.post( url, $form.serialize() );

    posting.done(function( data ) {
      $form.hide();
      $('#recover-password p.note, #recover-password2 p.note').text("We've sent you an email with a link to update your password.");
      setTimeout(function(){
        //copied from function on theme. ?
      	document.getElementById('recover-password').style.display = 'none';
        document.getElementById('customer').style.display = 'inline-block';
        document.getElementById('customer2').style.display = 'inline-block';
        $form.show();
        $('#recover-password p.note, #recover-password2 p.note').text("We will send you an email to reset your password.");
      }, 2000);
    });
  });


/****************************************************************/
/* DETAIL PAGE - SHOW FIT GUIDE WHEN CLICKING SIZE GUIDE TEXT   */
/****************************************************************/
  sizeLabelHandler();



/********************************/
/* DR - HOVER TO VIEW DETAILS   */
/********************************/
  $( '#view-deets' ).click(function() {
    $( '.detail-container' ).toggle();
  });


/*************************************/
/* SET HEIGHT OF NAVIGATION BELOW 740*/
/*************************************/
  function setHeight() {
    $('header').css({'top':'0'});
    var marTop = ($('header').height() + 10);
    //$('.page-wrap').css({'margin-top':marTop})
  }

  if ($(window).width() < 980){
      setHeight();
   };

  $(window).resize(function() {
    if ($(window).width() < 980){
      setHeight();
    } else {
      $('.page-wrap').css({'margin-top':'initial'})
    }
  });


}); //End document.ready




$(document).ready(function () {

  if ($('#currentemail').val() == '')
    $('#currentemail').val(localStorage.getItem('_email'));


  	var url =  window.location.href;
    var redir = localStorage.getItem('_redir');
 	localStorage.setItem('_redir', '');
    $("#redirect_url").val(url);
});



$(window).load(function() {
    $('.main-content').fadeIn();
});




/***********************************************/
/* SIZE GUIDE - CLOSE IF CLICKING OUTSIDE IT   */
/***********************************************/
$(document).mouseup(function(e) {
  var $sizeChart = $("#sizeChart");

  // if the target of the click isn't the container nor a descendant of the container
  if (!$sizeChart.is(e.target) && $sizeChart.has(e.target).length === 0) {
    $sizeChart.hide();
  }


/*************************************************************/
/* DRESSING ROOM - CLOSE DETAIL BOX IF CLICKING OUTSIDE IT   */
/*************************************************************/
  var $container = $(".detail-container");

  // if the target of the click isn't the container nor a descendant of the container
  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $container.hide();
  }

/***********************************************/
/* POPUP MODAL - CLOSE IF CLICKING OUTSIDE IT  */
/***********************************************/
  var $popupModal = $(".dr-pop");

  // if the target of the click isn't the container nor a descendant of the container
  if (!$popupModal.is(e.target) && $popupModal.has(e.target).length === 0) {
    $popupModal.hide();
    $('.ui-widget-overlay').hide();
  }
});

/**********************************/
/*    DETAIL - SHOW COLOR NAME    */
/**********************************/
var dont = false;

$(window).load(function(){
  //Displays the name of the swatch when the page loads
  var swatchChoice = $('.currentSwatch').attr('data-name');
  $('.sm-lbl').text( '| ' + swatchChoice);

    //$('select.single-option-selector').change(function(){
      setTimeout(function(){
        captureCuPDPJustSwatchChange();
        $('select#currencies').trigger('change');
      }, 200);
    //});
  /**
    $('span.product-price').on('DOMSubtreeModified', function () {
      	if (dont == true)
          return;
      	dont = true;
      	if ($("span.money").data('ca') == undefined)
        {
        	captureCuPDPJustSwatchChange();
        }
        console.log('past xxx');
            	var valueSelected = $('select#currencies').val();
      	console.log(valueSelected);
				var z = $(this).find('span.money');
                if (valueSelected == 'CAD')
         		{
                  console.log('in 1');
                    if ($(z).data('ca') == undefined)
                    {
                      dont = false;
                      return;
                    }
                    console.log('in ca2');
                  	var dollhair = $(z).data('ca').toString();
                    var val = dollhair.replace('$','');
                    val = val / Currency.rates['CAD'];
                  	val = val + .02;
                  	if ($('#extralength').is(':checked') == true)
                      val += 10;
                    val = '$' + Math.floor(val) + '.00 CAD';
                  	if ($(z).text() != val)
                    {
                      	console.log(val);
                      	console.log($(z).text());
                    	$(z).text(val);
                    }
                }
                else
                {
                  console.log('in 2');
                  	var yous = '$'+$(z).data('us');
                  	console.log(yous);
                    if ($('#extralength').is(':checked') == true)
                    {
                      yous = Math.floor(yous.replace('$',''));
                      yous += 10;
                      yous = '$' + yous.toString() + '.00';
                    }
                  	if ($(z).text() != yous)
                    {
                      	console.log(yous);
                      	console.log($(z).text());
                  		$(z).text(yous);
                    }
                }
      dont = false;
	});
  **/
  //Changes the name of the swatch when the user clicks on a new swatch
  $('.swatchColor').click(function(){
      var swatchChoice = $('.currentSwatch').attr('data-name');
      $('.sm-lbl').text( '| ' + swatchChoice);
  });
});
